// Strip PII (CustomerPhoneNumber) before forwarding payload to telemetry.
export const sanitizeForSentry = <T extends { CustomerPhoneNumber?: string }>(
  variables: T
): Omit<T, 'CustomerPhoneNumber'> => {
  const rest = { ...variables };
  delete rest.CustomerPhoneNumber;
  return rest;
};
